import React from 'react'

import { setToggleBlacklistStatus } from '../../slices'
import { ActionCheckbox } from '../../../../ui'

export const WhitelistCheckbox = ({ rowData }) => {
  if (!rowData) {
    return null
  }

  return (
    <ActionCheckbox
      rowData={rowData}
      checkedField="isInWhitelist"
      actionType="white"
      action={setToggleBlacklistStatus}
    />
  )
}
